<div class="container">
    @if (avatar) {
        <div class="avatar" [ngClass]="{ small: size() === 'small' }">
            <span>{{ avatar }}</span>
        </div>
    }
</div>
